<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ------------------------------------------------ ----------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
    <vx-card :title="$t('Filter')" class="mb-base">
      <!-- <vs-button class="vx-col lg:w-1/6 w-full mt-5" @click="ResetFilter" >Reset Filter</vs-button> -->
      <div class="vx-row">
        <div class="vx-col lg:w-1/6 w-full mt-5">
          <label class="vs-input--label">{{$t('Level')}}</label>
          <v-select
            label="Name"
            v-model="search.LevelID"
            :options="getCourseLevel"
            :reduce="(Level) => Level.ID"
          />
        </div>
        <div class="vx-col lg:w-1/6 w-full mt-5">
          <label class="vs-input--label">{{$t('Language')}}</label>
          <v-select
            label="Name"
            autocomplete
            v-model="search.LanguageID"
            :options="getLanguage"
            :reduce="(language) => language.ID"
          />
        </div>
        <!-- <vs-select    autocomplete class="vx-col lg:w-1/6 w-full mt-5" label="language" v-model="search.LanguageID" >
                      <vs-select-item :key="index" :value="item.ID" :text="item.Name" v-for="(item,index) in getLanguage" />
                    </vs-select> -->
        <div class="vx-col lg:w-1/6 w-full mt-5">
          <label class="vs-input--label">{{$t('AreaOfStudy')}}</label>
          <v-select
            label="Name"
            autocomplete
            v-model="search.AreaOfStudyID"
            :options="getCourseAreaOfStudyList"
            :reduce="(CourseAreaOfStudy) => CourseAreaOfStudy.ID"
          />
        </div>

        <div class="vx-col lg:w-1/6 w-full mt-5">
          <label class="vs-input--label">{{$t('IndustrySector')}}</label>
          <v-select
            label="Name"
            autocomplete
            v-model="search.IndustrySectorID"
            :options="getindustrySector"
            :reduce="(IndustrySector) => IndustrySector.ID"
          />
        </div>

        <div class="vx-col lg:w-1/6 w-full mt-5">
          <label class="vs-input--label">{{$t('Provider')}}</label>
          <v-select
            label="Name"
            autocomplete
            v-model="search.ProviderID"
            :options="Providers"
            :reduce="(Provider) => Provider.ID"
          />
        </div>
        <!-- <vs-select    autocomplete class="vx-col lg:w-1/6 w-full mt-5" label="Provider" v-model="search.ProviderID">
                      <vs-select-item :key="index" :value="item.ID" :text="item.Name" v-for="(item,index) in Providers" />
                    </vs-select> -->
        <vs-input
         :label="$t('Keyword')"
          class="vx-col lg:w-1/6 w-full mt-5"
          v-model="search.KeyWord"
          name="name"
        />
        <span class="text-danger text-sm" v-show="errors.has('KeyWord')">{{
          errors.first("KeyWord")
        }}</span>
        <!-- <vs-button  class="vx-col lg:w-1/6 w-full mt-5" color="success" @click="Filter()">Search</vs-button> -->
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="mt-8 flex flex-wrap items-center justify-end">
              <vs-button class="mr-6" @click="Filter">{{$t('Search')}}</vs-button>
              <vs-button type="border" color="danger" @click="ResetFilter"
                >{{$t('Reset')}}</vs-button
              >
            </div>
          </div>
        </div>
        <!-- <vs-button class="vx-col lg:w-1/7 w-full mt-5" @click="Filter" :disabled="!search">Filter</vs-button> -->
      </div>
    </vx-card>

    <vs-table
      ref="table"
      pagination
      :max-items="itemsPerPage"
      search
      :data="tracks"
      v-if="!addNewDataSidebar"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="vx-row">
          <vs-button
            type="border"
            icon-pack="feather"
            icon="icon-plus"
            :to="{ name: 'Track-add/Edit' }"
            >{{$t('AddNew')}}</vs-button
          >
          <!-- <vs-button type="border" icon-pack="feather" icon="icon-plus" class="ml-10" @click="activeCourseImport=true">Import from CSV</vs-button>
            <vs-button type="border" icon-pack="feather" icon="icon-download" class="ml-10" @click="downloadCourseTemplate">CSV template</vs-button> -->
        </div>
        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="
              p-4
              border border-solid
              d-theme-border-grey-light
              rounded-full
              d-theme-dark-bg
              cursor-pointer
              flex
              items-center
              justify-between
              font-medium
            "
          >
            <span class="mr-2"
              >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                tracks.length - currentPage * itemsPerPage > 0
                  ? currentPage * itemsPerPage
                  : tracks.length
              }}
              of {{ tracks.length }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="Name">{{$t('Name')}}</vs-th>
        <vs-th sort-key="Code">{{$t('Code')}}</vs-th>
        <vs-th sort-key="Provider">{{$t('Provider')}}</vs-th>

        <vs-th>{{$t('Action')}}</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <tr
            :data="tr"
            :key="indextr"
            v-for="(tr, indextr) in data"
            @click="editData(tr.ID)"
            :to="{ name: 'Track-add/Edit', params: { ID: tr.ID } }"
          >
            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.Name }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.Code }}</p>
            </vs-td>

            <vs-td>
              <p
                class="product-name font-medium truncate"
                v-if="tr.Provider != undefiend"
              >
                {{ tr.Provider.Name }}
              </p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="editData(tr.ID)"
              />
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="openConfirm(tr)"
              />
              <feather-icon
                icon="PrinterIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="print(tr)"
              />
            </vs-td>
          </tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>


<script>
import vSelect from "vue-select";
import moduleTrack from "@/store/track/moduleTrack.js";
import { domain, mainSetting } from "@/gloabelConstant.js";
import moduleCourseLevel from "@/store/settings/courseLevel/moduleCourseLevel.js";
import moduleLanguage from "@/store/settings/language/moduleLanguage.js";
import moduleIndustrySector from "@/store/settings/industrySector/moduleIndustrySector.js";
import moduleCourseAreaOfStudy from "@/store/settings/courseAreaOfStudy/moduleCourseAreaOfStudy.js";
import moduleProvider from "@/store/settings/provider/moduleProvider.js";
import modulePopulationList from "@/store/settings/populationList/modulePopulationList.js";

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      search: {},
      UploadRequestHeader: mainSetting.UploadRequestHeader,
      uploadUrl: domain + "API/Course/ImportCourse",
      activeCourseImport: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
      },
      activePrompt: false,
      selected: [],
      first: true,
      itemsPerPage: 10,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,

      rowDataForDelete: {},
      activeConfirm: false,
    };
  },
  computed: {
    // currentPage() {
    //   if (this.isMounted) {
    //     return this.$refs.table.currentx;
    //   }
    //   return 0;
    // },
    currentPage() {
      debugger;
      if (this.isMounted) {
        if (!this.first)
          this.$store.state.trackList.search.pageNum =
            this.$refs.table.currentx;
        this.first = false;
        return this.$refs.table.currentx;
      }
      return 0;
    },
    tracks() {
      return this.$store.state.trackList.tracks;
    },
    Providers() {
      return this.$store.state.ProviderList.providers;
    },

    getCourseLevel() {
      return this.$store.state.courseLevelList.courseLevels;
    },
    getLanguage() {
      return this.$store.state.languageList.languages;
    },
    getindustrySector() {
      return this.$store.state.industrySectorList.industrySectors;
    },
    getCourseAreaOfStudyList() {
      return this.$store.state.courseAreaOfStudyList.courseAreaOfStudies;
    },
  },

  methods: {
    print(data) {
      window.open("#/Report/DiplomaDetail/" + data.ID, "_blank");
    },
    ResetFilter() {
      this.search = {};
      this.$store.dispatch("trackList/fetchDataListItems");
    },
    Filter() {
      this.$store
        .dispatch("trackList/fetchDataListItemsByFilter", this.search)
        .catch((err) => {
          console.error(err);
        });
    },

    successUpload(event) {
      debugger;
      console.log(event);
      this.$vs.notify({
        time: 8000,
        color: "success",
        title: "Upload Success",
       text: this.$t("ImportedCourseAddScuessfully")


      });
      this.activeCourseImport = false;
      this.$store.dispatch("trackList/fetchDataListItems");
    },

    editData(ID) {
      this.$router.push({ name: "Track-add/Edit", params: { ID: ID } });
    },

    deleteData(data) {
      this.$store.dispatch("trackList/removeItem", data).catch((err) => {
        console.error(err);
      });
    },

    openConfirm(data) {
      this.rowDataForDelete = data;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("Confirm"),
        text: this.$t("Areyousureyouwantdeletethisrecord")+"?",
        accept: this.acceptAlert,
      });
    },

    acceptAlert() {
      this.deleteData(this.rowDataForDelete);
      this.$vs.notify({
        time: 8000,
        color: "danger",
        title: this.$t("Deletedrecord"),
       text: this.$t("Theselectedrecordwassuccessfullydeleted")
      });
    },
  },

  created() {
    if (!moduleTrack.isRegistered) {
      this.$store.registerModule("trackList", moduleTrack);
      moduleTrack.isRegistered = true;
    }
    var vm = this;
    this.$store.dispatch("trackList/fetchDataListItems").then(() => {
      vm.$refs.table.currentx = vm.$store.state.trackList.search.pageNum;
    });

    if (!moduleCourseLevel.isRegistered) {
      this.$store.registerModule("courseLevelList", moduleCourseLevel);
      moduleCourseLevel.isRegistered = true;
    }

    if (!moduleLanguage.isRegistered) {
      this.$store.registerModule("languageList", moduleLanguage);
      moduleLanguage.isRegistered = true;
    }

    if (!moduleIndustrySector.isRegistered) {
      this.$store.registerModule("industrySectorList", moduleIndustrySector);
      moduleIndustrySector.isRegistered = true;
    }
    if (!moduleCourseAreaOfStudy.isRegistered) {
      this.$store.registerModule(
        "courseAreaOfStudyList",
        moduleCourseAreaOfStudy
      );
      moduleCourseAreaOfStudy.isRegistered = true;
    }

    if (!moduleProvider.isRegistered) {
      this.$store.registerModule("ProviderList", moduleProvider);
      moduleProvider.isRegistered = true;
    }
    if (!modulePopulationList.isRegistered) {
      this.$store.registerModule("populationListList", modulePopulationList);
      modulePopulationList.isRegistered = true;
    }

    if (this.$store.state.populationListList.populationLists.length == 0)
      this.$store.dispatch("populationListList/fetchDataListItems");
    if (this.$store.state.ProviderList.providers.length == 0)
      this.$store.dispatch("ProviderList/fetchDataListItems");
    if (this.$store.state.courseAreaOfStudyList.courseAreaOfStudies.length == 0)
      this.$store.dispatch("courseAreaOfStudyList/fetchDataListItems");
    if (this.$store.state.industrySectorList.industrySectors.length == 0)
      this.$store.dispatch("industrySectorList/fetchDataListItems");
    if (this.$store.state.languageList.languages.length == 0)
      this.$store.dispatch("languageList/fetchDataListItems");
    if (this.$store.state.courseLevelList.courseLevels.length == 0)
      this.$store.dispatch("courseLevelList/fetchDataListItems");
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>

<style lang="css">
.disabled-upload {
  display: none;
}
</style>
